import axios from 'axios';
import toCamelCase from '../utils/camelCase';

export const getEarliestDelivery = (itemIds, zipCode) => {
  const url = `https://www.homedepot.com/mcc-cart/v3/appliance/deliveryAvailability/${itemIds}/zipCode/${zipCode}`;

  return axios.get(url)
    .then((response) => toCamelCase(response.data));
};
